<template>
    <div class="a">
        <top></top>
        <navs></navs>
        <div class="content">
            <div class="time">
                <div class="cont">
                    <div class="cont_a">
                        <div class="bule"></div>
                        <div class="p">圣剧欣赏</div>
                    </div>
                    <div class="cont_b">
                        <div class="cont_text" v-for="(item,index) in list" :key="index" @click="go(item.id)">
                            <div class="cont_title">{{ item.name }}</div>
                            <div class="cont_time">{{item.createTime}}&nbsp;&nbsp;&nbsp;></div>
                        </div>
                        
                    </div>
                </div>
                
            </div>
        </div>
        <el-dialog title="手机号登录" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="手机号码" :label-width="formLabelWidth">
                    <el-input v-model="form.phone" autocomplete="off" style="width: 300px;"></el-input>
                </el-form-item>
                <!-- <el-form-item label="图片验证" :label-width="formLabelWidth">
                    <el-input v-model="form.captcha" autocomplete="off" style="width: 300px;"></el-input>
                    <img :src="img" alt="" @click="captcha" style="height: 20px;width: 100px;">
                </el-form-item> -->
                <el-form-item label="短信验证" :label-width="formLabelWidth">
                    <el-input v-model="form.dx" autocomplete="off" style="width: 300px;"></el-input>
                    <el-button @click="getyz">获取短信验证码</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">登 录</el-button>
            </div>
        </el-dialog>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import axios from "axios"
import { witness, getyz } from "../api/index"
export default {
    components: {
        top,
        bottom,
        navs
    },
    data(){
        return{
            list:[],
            dialogTableVisible: false,
            dialogFormVisible: false,
            form: {
                phone: '',
                captcha: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            formLabelWidth: '120px',
            img: "https://www.jnccljh.com/api/images",
            name:""
        }
    },
    created(){
        axios({
            method:"GET",
            url:"https://www.jnccljh.com/api/searches?name="+this.$route.query.name
        }).then(res=>{
            console.log(res)
            // this.tlist = res.data.data
            this.list = res.data.data
        })
    },

    methods:{
        submit() {
            this.dialogFormVisible = false
            const data = { "account": this.form.phone, thirdType: "SMS", mobileText: this.form.dx };
            axios.post('https://www.jnccljh.com/api/login', data).then(res => {
                console.log(res)
                if (res.data.data.accessToken != "") {
                    this.$message({
                        message: '登录成功',
                        type: 'success'
                    });
                    localStorage.setItem("token", res.data.data.accessToken)
                }
            })
        },
        getyz() {
            // getyz({

            //         "captchaCode": this.form.captcha
            // }).then(res=>{
            //     console.log(res)
            // })
            const data = { "account": this.form.phone };
            axios.post('https://www.jnccljh.com/api/sms', data);
            // axios({
            //     method: "POST",
            //     url: "https://www.jnccljh.com/api/sms",
            //     params: {
            //         "account": this.form.phone,
            //         "captchaCode": this.form.captcha
            //     }
            // }).then(res => {
            //     console.log(res)

            // })
        },
        go(item){
            if(localStorage.getItem("token") != null){
              this.$router.push({path:"/lh",query:{id:item}})
          }else{
              this.dialogFormVisible = true
          }
        }
    }
}
</script>
<style scoped>
.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
}
.content{
    width: 100%;
    /* height: 480px; */
    /* height: 1330px; */
    background-image: url(../image/back.png);
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
}
.time{
    width: 70%;
    margin: 0 auto;
    /* height: 1330px; */
    /* background-color: #F7F7F7; */
    display: flex;
    flex-direction: column;
    align-items: center;
}
.bule{
    width: 5px;
height: 16px;
background: #1463FF;
}
.p{
    margin-left: 5px;
    font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 17px;
color: #333333;
line-height: 17px;
font-style: normal;
}
.cont{
    width: 100%;
    margin: 0 auto;

}
.cont_a{
    height: 74px;
    display: flex;
    align-items: center;
}
.cont_b{
    padding: 20px;
    background-color: #FFFFFF;
    margin-bottom: 20px;
}
.cont_text{
    height: 50px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.cont_text:hover{
    height: 50px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1463FF;
}
.cont_title{
    width: 146px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.cont_time{
    font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 11px;
color: #999999;
}
</style>


// WEBPACK FOOTER //
// src/views/search.vue